module.exports = __webpack_public_path__ + "img/arrow-right-from-bracket.b815af7a.svg";